function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import { CodedError, NativeModulesProxy } from 'expo-modules-core';
import { Platform, NativeModules } from "react-native-web";
import { AppOwnership, ExecutionEnvironment, UserInterfaceIdiom } from "./Constants.types";
import ExponentConstants from "./ExponentConstants";
export { AppOwnership, ExecutionEnvironment, UserInterfaceIdiom };
if (!ExponentConstants) {
  console.warn("No native ExponentConstants module found, are you sure the expo-constants's module is linked properly?");
}
var rawManifest = null;
// If expo-updates defines a non-empty manifest, prefer that one
if (NativeModulesProxy.ExpoUpdates) {
  var updatesManifest;
  if (NativeModulesProxy.ExpoUpdates.manifest) {
    updatesManifest = NativeModulesProxy.ExpoUpdates.manifest;
  } else if (NativeModulesProxy.ExpoUpdates.manifestString) {
    updatesManifest = JSON.parse(NativeModulesProxy.ExpoUpdates.manifestString);
  }
  if (updatesManifest && Object.keys(updatesManifest).length > 0) {
    rawManifest = updatesManifest;
  }
}
// If dev-launcher defines a non-empty manifest, prefer that one
if (NativeModules.EXDevLauncher) {
  var devLauncherManifest;
  if (NativeModules.EXDevLauncher.manifestString) {
    devLauncherManifest = JSON.parse(NativeModules.EXDevLauncher.manifestString);
  }
  if (devLauncherManifest && Object.keys(devLauncherManifest).length > 0) {
    rawManifest = devLauncherManifest;
  }
}
// Fall back to ExponentConstants.manifest if we don't have one from Updates
if (!rawManifest && ExponentConstants && ExponentConstants.manifest) {
  rawManifest = ExponentConstants.manifest;
  // On Android we pass the manifest in JSON form so this step is necessary
  if (typeof rawManifest === 'string') {
    rawManifest = JSON.parse(rawManifest);
  }
}
var _ref = ExponentConstants || {},
  name = _ref.name,
  appOwnership = _ref.appOwnership,
  nativeConstants = _objectWithoutProperties(_ref, ["name", "appOwnership"]);
var warnedAboutManifestField = false;
var constants = _objectSpread(_objectSpread({}, nativeConstants), {}, {
  // Ensure this is null in bare workflow
  appOwnership: appOwnership !== null && appOwnership !== void 0 ? appOwnership : null
});
Object.defineProperties(constants, {
  installationId: {
    get: function get() {
      return nativeConstants.installationId;
    },
    enumerable: false
  },
  /**
   * Use `manifest` property by default.
   * This property is only used for internal purposes.
   * It behaves similarly to the original one, but suppresses warning upon no manifest available.
   * `expo-asset` uses it to prevent users from seeing mentioned warning.
   */
  __unsafeNoWarnManifest: {
    get: function get() {
      var maybeManifest = getManifest(true);
      if (!maybeManifest || !isAppManifest(maybeManifest)) {
        return null;
      }
      return maybeManifest;
    },
    enumerable: false
  },
  __unsafeNoWarnManifest2: {
    get: function get() {
      var maybeManifest = getManifest(true);
      if (!maybeManifest || !isManifest(maybeManifest)) {
        return null;
      }
      return maybeManifest;
    },
    enumerable: false
  },
  manifest: {
    get: function get() {
      if (__DEV__ && !warnedAboutManifestField) {
        console.warn("Constants.manifest has been deprecated in favor of Constants.expoConfig.");
        warnedAboutManifestField = true;
      }
      var maybeManifest = getManifest();
      if (!maybeManifest || !isAppManifest(maybeManifest)) {
        return null;
      }
      return maybeManifest;
    },
    enumerable: true
  },
  manifest2: {
    get: function get() {
      var maybeManifest = getManifest();
      if (!maybeManifest || !isManifest(maybeManifest)) {
        return null;
      }
      return maybeManifest;
    },
    enumerable: true
  },
  expoConfig: {
    get: function get() {
      var maybeManifest = getManifest(true);
      if (!maybeManifest) {
        return null;
      }
      if (isManifest(maybeManifest)) {
        var _maybeManifest$extra$, _maybeManifest$extra;
        return (_maybeManifest$extra$ = (_maybeManifest$extra = maybeManifest.extra) === null || _maybeManifest$extra === void 0 ? void 0 : _maybeManifest$extra.expoClient) !== null && _maybeManifest$extra$ !== void 0 ? _maybeManifest$extra$ : null;
      } else if (isAppManifest(maybeManifest)) {
        return maybeManifest;
      }
      return null;
    },
    enumerable: true
  },
  expoGoConfig: {
    get: function get() {
      var maybeManifest = getManifest(true);
      if (!maybeManifest) {
        return null;
      }
      if (isManifest(maybeManifest)) {
        var _maybeManifest$extra$2, _maybeManifest$extra2;
        return (_maybeManifest$extra$2 = (_maybeManifest$extra2 = maybeManifest.extra) === null || _maybeManifest$extra2 === void 0 ? void 0 : _maybeManifest$extra2.expoGo) !== null && _maybeManifest$extra$2 !== void 0 ? _maybeManifest$extra$2 : null;
      } else if (isAppManifest(maybeManifest)) {
        return maybeManifest;
      }
      return null;
    },
    enumerable: true
  },
  easConfig: {
    get: function get() {
      var maybeManifest = getManifest(true);
      if (!maybeManifest) {
        return null;
      }
      if (isManifest(maybeManifest)) {
        var _maybeManifest$extra$3, _maybeManifest$extra3;
        return (_maybeManifest$extra$3 = (_maybeManifest$extra3 = maybeManifest.extra) === null || _maybeManifest$extra3 === void 0 ? void 0 : _maybeManifest$extra3.eas) !== null && _maybeManifest$extra$3 !== void 0 ? _maybeManifest$extra$3 : null;
      } else if (isAppManifest(maybeManifest)) {
        return maybeManifest;
      }
      return null;
    },
    enumerable: true
  },
  __rawManifest_TEST: {
    get: function get() {
      return rawManifest;
    },
    set: function set(value) {
      rawManifest = value;
    },
    enumerable: false
  }
});
function isAppManifest(manifest) {
  return !isManifest(manifest);
}
function isManifest(manifest) {
  return 'metadata' in manifest;
}
function getManifest() {
  var suppressWarning = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  if (!rawManifest) {
    var invalidManifestType = rawManifest === null ? 'null' : 'undefined';
    if (nativeConstants.executionEnvironment === ExecutionEnvironment.Bare && Platform.OS !== 'web') {
      if (!suppressWarning) {
        console.warn("Constants.manifest is ".concat(invalidManifestType, " because the embedded app.config could not be read. Ensure that you have installed the expo-constants build scripts if you need to read from Constants.manifest."));
      }
    } else if (nativeConstants.executionEnvironment === ExecutionEnvironment.StoreClient || nativeConstants.executionEnvironment === ExecutionEnvironment.Standalone) {
      // If we somehow get here, this is a truly exceptional state to be in.
      // Constants.manifest should *always* be defined in those contexts.
      throw new CodedError('ERR_CONSTANTS_MANIFEST_UNAVAILABLE', "Constants.manifest is ".concat(invalidManifestType, ", must be an object."));
    }
  }
  return rawManifest;
}
export default constants;